import { render, staticRenderFns } from "./happy-data.vue?vue&type=template&id=f3a01df8&"
import script from "./happy-data.vue?vue&type=script&lang=js&"
export * from "./happy-data.vue?vue&type=script&lang=js&"
import style0 from "./happy-data.vue?vue&type=style&index=0&id=f3a01df8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports